module.exports = __webpack_public_path__ + "media/images/u5707-219a418d9479cb52531ff4065ff35e31.png";